/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Sections_Latestofferswithachievements3Inputs */

const id_home_sections_latestofferswithachievements3 = /** @type {(inputs: Home_Sections_Latestofferswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penawaran Terbaru dgn Pencapaian`)
};

const ms_home_sections_latestofferswithachievements3 = /** @type {(inputs: Home_Sections_Latestofferswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tawaran Terkini dgn Pencapaian`)
};

const da_home_sections_latestofferswithachievements3 = /** @type {(inputs: Home_Sections_Latestofferswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seneste Tilbud m/ Achievements`)
};

const de_home_sections_latestofferswithachievements3 = /** @type {(inputs: Home_Sections_Latestofferswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neueste Angebote m/ Errungenschaften`)
};

const en_us2_home_sections_latestofferswithachievements3 = /** @type {(inputs: Home_Sections_Latestofferswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latest Offers w/ Achievements`)
};

const es_es2_home_sections_latestofferswithachievements3 = /** @type {(inputs: Home_Sections_Latestofferswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juegos recientes con logros`)
};

const es_mx2_home_sections_latestofferswithachievements3 = /** @type {(inputs: Home_Sections_Latestofferswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas recientes c/ logros`)
};

const fil_home_sections_latestofferswithachievements3 = /** @type {(inputs: Home_Sections_Latestofferswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Pinakabagong Offer na may Achievements`)
};

const fr_home_sections_latestofferswithachievements3 = /** @type {(inputs: Home_Sections_Latestofferswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offres récentes avec succès`)
};

const it_home_sections_latestofferswithachievements3 = /** @type {(inputs: Home_Sections_Latestofferswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultime offerte con risultati`)
};

const hu_home_sections_latestofferswithachievements3 = /** @type {(inputs: Home_Sections_Latestofferswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legújabb ajánlatok teljesítményekkel`)
};

const nl_home_sections_latestofferswithachievements3 = /** @type {(inputs: Home_Sections_Latestofferswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieuwste aanbiedingen met prestaties`)
};

const no_home_sections_latestofferswithachievements3 = /** @type {(inputs: Home_Sections_Latestofferswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siste tilbud med prestasjoner`)
};

const pl_home_sections_latestofferswithachievements3 = /** @type {(inputs: Home_Sections_Latestofferswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najnowsze oferty z osiągnięciami`)
};

const pt_br2_home_sections_latestofferswithachievements3 = /** @type {(inputs: Home_Sections_Latestofferswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogos recentes com conquistas`)
};

const pt_home_sections_latestofferswithachievements3 = /** @type {(inputs: Home_Sections_Latestofferswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas recentes com conquistas`)
};

const ro_home_sections_latestofferswithachievements3 = /** @type {(inputs: Home_Sections_Latestofferswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferte recente cu realizări`)
};

const fi_home_sections_latestofferswithachievements3 = /** @type {(inputs: Home_Sections_Latestofferswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viimeisimmät tarjoukset saavutuksilla`)
};

const sv_home_sections_latestofferswithachievements3 = /** @type {(inputs: Home_Sections_Latestofferswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senaste erbjudanden med prestationer`)
};

const vi_home_sections_latestofferswithachievements3 = /** @type {(inputs: Home_Sections_Latestofferswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ưu đãi mới có thành tích`)
};

const tr_home_sections_latestofferswithachievements3 = /** @type {(inputs: Home_Sections_Latestofferswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başarımlı Son Teklifler`)
};

const cs_home_sections_latestofferswithachievements3 = /** @type {(inputs: Home_Sections_Latestofferswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejnovější nabídky s úspěchy`)
};

const bg_home_sections_latestofferswithachievements3 = /** @type {(inputs: Home_Sections_Latestofferswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Най-нови оферти с постижения`)
};

const ru_home_sections_latestofferswithachievements3 = /** @type {(inputs: Home_Sections_Latestofferswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последние предложения с достижениями`)
};

const uk_home_sections_latestofferswithachievements3 = /** @type {(inputs: Home_Sections_Latestofferswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нові пропозиції з досягненнями`)
};

const ar_home_sections_latestofferswithachievements3 = /** @type {(inputs: Home_Sections_Latestofferswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أحدث العروض مع الإنجازات`)
};

const hi_home_sections_latestofferswithachievements3 = /** @type {(inputs: Home_Sections_Latestofferswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपलब्धियों वाले नवीनतम ऑफ़र`)
};

const th_home_sections_latestofferswithachievements3 = /** @type {(inputs: Home_Sections_Latestofferswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อเสนอใหม่ที่มีความสำเร็จ`)
};

const ja_home_sections_latestofferswithachievements3 = /** @type {(inputs: Home_Sections_Latestofferswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`実績付き最新オファー`)
};

const zh_cn2_home_sections_latestofferswithachievements3 = /** @type {(inputs: Home_Sections_Latestofferswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`带成就的最新目录项`)
};

const zh_hant1_home_sections_latestofferswithachievements3 = /** @type {(inputs: Home_Sections_Latestofferswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`帶成就的最新目錄項目`)
};

const ko_home_sections_latestofferswithachievements3 = /** @type {(inputs: Home_Sections_Latestofferswithachievements3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`도전 과제 포함 최신 오퍼`)
};

/**
* | output |
* | --- |
* | "Latest Offers w/ Achievements" |
*
* @param {Home_Sections_Latestofferswithachievements3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_sections_latestofferswithachievements3 = /** @type {((inputs?: Home_Sections_Latestofferswithachievements3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Sections_Latestofferswithachievements3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_sections_latestofferswithachievements3(inputs)
	if (locale === "ms") return ms_home_sections_latestofferswithachievements3(inputs)
	if (locale === "da") return da_home_sections_latestofferswithachievements3(inputs)
	if (locale === "de") return de_home_sections_latestofferswithachievements3(inputs)
	if (locale === "en-US") return en_us2_home_sections_latestofferswithachievements3(inputs)
	if (locale === "es-ES") return es_es2_home_sections_latestofferswithachievements3(inputs)
	if (locale === "es-MX") return es_mx2_home_sections_latestofferswithachievements3(inputs)
	if (locale === "fil") return fil_home_sections_latestofferswithachievements3(inputs)
	if (locale === "fr") return fr_home_sections_latestofferswithachievements3(inputs)
	if (locale === "it") return it_home_sections_latestofferswithachievements3(inputs)
	if (locale === "hu") return hu_home_sections_latestofferswithachievements3(inputs)
	if (locale === "nl") return nl_home_sections_latestofferswithachievements3(inputs)
	if (locale === "no") return no_home_sections_latestofferswithachievements3(inputs)
	if (locale === "pl") return pl_home_sections_latestofferswithachievements3(inputs)
	if (locale === "pt-BR") return pt_br2_home_sections_latestofferswithachievements3(inputs)
	if (locale === "pt") return pt_home_sections_latestofferswithachievements3(inputs)
	if (locale === "ro") return ro_home_sections_latestofferswithachievements3(inputs)
	if (locale === "fi") return fi_home_sections_latestofferswithachievements3(inputs)
	if (locale === "sv") return sv_home_sections_latestofferswithachievements3(inputs)
	if (locale === "vi") return vi_home_sections_latestofferswithachievements3(inputs)
	if (locale === "tr") return tr_home_sections_latestofferswithachievements3(inputs)
	if (locale === "cs") return cs_home_sections_latestofferswithachievements3(inputs)
	if (locale === "bg") return bg_home_sections_latestofferswithachievements3(inputs)
	if (locale === "ru") return ru_home_sections_latestofferswithachievements3(inputs)
	if (locale === "uk") return uk_home_sections_latestofferswithachievements3(inputs)
	if (locale === "ar") return ar_home_sections_latestofferswithachievements3(inputs)
	if (locale === "hi") return hi_home_sections_latestofferswithachievements3(inputs)
	if (locale === "th") return th_home_sections_latestofferswithachievements3(inputs)
	if (locale === "ja") return ja_home_sections_latestofferswithachievements3(inputs)
	if (locale === "zh-CN") return zh_cn2_home_sections_latestofferswithachievements3(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_sections_latestofferswithachievements3(inputs)
	return ko_home_sections_latestofferswithachievements3(inputs)
});
export { home_sections_latestofferswithachievements3 as "home.sections.latestOffersWithAchievements" }